/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagComputedFormula } from '../../models/tag-computed-formula';
import { TagComputedFormulaCalculateResult } from '../../models/tag-computed-formula-calculate-result';

export interface CalculateFormula$Params {
      body: TagComputedFormula
}

export function calculateFormula(http: HttpClient, rootUrl: string, params: CalculateFormula$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedFormulaCalculateResult>> {
  const rb = new RequestBuilder(rootUrl, calculateFormula.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagComputedFormulaCalculateResult>;
    })
  );
}

calculateFormula.PATH = '/tags-computed/calculate';
